// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__pjSpj","productName":"Table_productName__1Jx0l"};